import React from "react";

export default function Transactions() {
  return <div>Transactions</div>;
}
